import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Seo } from "@/components/Seo";
import { useLanguage } from "../i18n";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <>
      <Seo title={`${t("Pagina non trovata")} — Alsera Studio`} description={t("La pagina che stai cercando non esiste o è stata spostata.")} />
      <section className="flex min-h-[70vh] items-center pt-32 pb-24" data-testid="not-found-page">
        <div className="mx-auto max-w-xl px-5 text-center sm:px-8">
          <p className="font-display text-7xl font-extrabold text-salvia">404</p>
          <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-antracite">{t("Pagina non trovata")}</h1>
          <p className="mt-4 text-base text-antracite/65">
            {t("La pagina che stai cercando non esiste o è stata spostata.")}
          </p>
          <Link to="/" className="btn-primary mt-8" data-testid="not-found-home">
            <Home className="h-4 w-4" /> {t("Torna alla home")}
          </Link>
        </div>
      </section>
    </>
  );
}
